import * as React from "react";
import type { SVGProps } from "react";

interface LegProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Leg = ({ cancelled = false, ...props }: LegProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.25 2.25)">
        <ellipse
          cx={8.083}
          cy={8.053}
          fill="#EFDFBF"
          stroke="#FFF"
          strokeWidth={3.25}
          rx={8.339}
          ry={8.336}
        />
        <ellipse
          cx={8.083}
          cy={8.053}
          stroke="#000"
          strokeWidth={2.5}
          rx={7.964}
          ry={7.961}
        />
      </g>
      <path
        fill="#000"
        d="m12.091 2.25-1.219 8.12 3.787-7.286 2.172 1.579-5.756 5.85 7.343-3.667.83 2.554-8.095 1.35 8.095 1.35-.83 2.553-7.342-3.665 5.755 5.85-2.172 1.578-3.786-7.283 1.218 8.117H9.406l1.218-8.117-3.785 7.283-2.173-1.579 5.755-5.849-7.341 3.665-.83-2.553 8.094-1.35L2.25 9.4l.83-2.554 7.342 3.667-5.756-5.85L6.84 3.084l3.784 7.281L9.406 2.25z"
      />
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M16.008 8.6a7.508 7.508 0 1 0 0 15.016 7.508 7.508 0 0 0 0-15.016"
        />
        <path
          fill="#007BBD"
          d="M16.008 9.327a6.781 6.781 0 1 1 0 13.562 6.781 6.781 0 0 1 0-13.562"
        />
        <path
          fill="#FFF"
          d="M18.982 19.983q-.628 0-.628-.686v-5.87l-.837.546q-.581.395-.907-.14-.336-.534.244-.895l1.395-.872q.21-.127.407-.18.198-.052.454-.052.488 0 .488.686v6.777q0 .686-.616.686M13.909 14.493c.25 0 .454.217.454.485l-.001 1.482 1.484.001c.268 0 .485.203.485.454 0 .25-.217.454-.485.454h-1.484l.001 1.484c0 .267-.203.484-.454.484-.25 0-.454-.217-.454-.484l-.001-1.485-1.483.001c-.267 0-.484-.203-.484-.454 0-.25.217-.454.484-.454h1.483v-1.483c0-.268.204-.485.455-.485"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Leg;
